import Repository from "./repository"

export default {
    post(params) {
        return Repository.post("/api/s207-password-changes/edit", params)
    }
}